import React from "react";
import moment from "moment";
import { PulseLoader } from "react-spinners";
import styles from "../LocationHistory.module.css";

const SimplePager = ({ currentPage, pages, changePage }) => {
  if (!pages || pages <= 1) return null;
  return (
    <>
      <button
        type="button"
        className={styles.pagerBtn}
        onClick={() => changePage(currentPage - 1)}
        disabled={currentPage <= 1}
        aria-label="Previous page"
      >
        ‹
      </button>
      <span className={styles.pagerLabel}>
        {currentPage} / {pages}
      </span>
      <button
        type="button"
        className={styles.pagerBtn}
        onClick={() => changePage(currentPage + 1)}
        disabled={currentPage >= pages}
        aria-label="Next page"
      >
        ›
      </button>
    </>
  );
};

const LocationHistoryList = ({
  heading,
  pagination,
  historyList,
  loading,
  selectedId,
  setGeoLocationMap,
  changePage,
  perPage,
  changePerPage,
}) => {
  return (
    <div className={styles.listCol}>
      <div className={styles.listHeader}>
        <div className={styles.listHeaderLeft}>
          <h6 className={styles.listTitle}>{heading}</h6>
          <p className={styles.listSubtitle}>Last 7 days</p>
        </div>
        <div className={styles.listControls}>
          <SimplePager
            currentPage={pagination.currentPage}
            pages={pagination.pages}
            changePage={changePage}
          />
          <select
            className={styles.perPageSelect}
            value={perPage}
            onChange={(e) => changePerPage(parseInt(e.target.value))}
            aria-label="Items per page"
          >
            {[5, 10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div className={styles.loader}>
          <PulseLoader
            color="#0077b6"
            loading={loading}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : historyList?.length ? (
        <ul className={styles.alertList}>
          {historyList.map((item) => {
            const isOut = item.fenceAlertType !== "IN_FENCE";
            const isActive = selectedId === item.id;
            return (
              <li key={item.id}>
                <button
                  type="button"
                  className={`${styles.alertCard} ${
                    isActive ? styles.alertCardActive : ""
                  }`}
                  onClick={() => setGeoLocationMap(item)}
                >
                  <div className={styles.alertTop}>
                    <span className={styles.alertTime}>
                      {moment(item.eventTimestamp).format(
                        "MMM D, YYYY · h:mm A",
                      )}
                    </span>
                    <span
                      className={`${styles.alertBadge} ${
                        isOut ? styles.badgeOut : styles.badgeIn
                      }`}
                    >
                      {isOut ? "Outside" : "Inside"}
                    </span>
                  </div>
                  <div className={styles.alertRows}>
                    <div className={styles.alertRow}>
                      <span className={styles.alertLabel}>Location</span>
                      <span className={styles.alertValue}>
                        {item?.address || "—"}
                      </span>
                    </div>
                    <div className={styles.alertRow}>
                      <span className={styles.alertLabel}>Safe zone</span>
                      <span className={styles.alertValue}>
                        {item?.safeLocation?.locationName || "—"}
                      </span>
                    </div>
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      ) : (
        <div className={styles.emptyState}>
          <p className={styles.emptyTitle}>No alerts found</p>
          <p className={styles.emptyDesc}>
            There is no location alert history for the last 7 days.
          </p>
        </div>
      )}
    </div>
  );
};

export default LocationHistoryList;
